import { TabPanel } from 'react-tabs'
import Flex from 'typescript-styled-flex'
import is from 'typescript-styled-is'
import styled from '../../../theme'

const BBTabPanel = styled(Flex.withComponent(TabPanel) as any)<
  IBBTabPanelProps
>`
  display: none;
  padding: ${({ size }) => (size ? 10 * size : 10)}px 0px;
  &.react-tabs__tab-panel--selected {
    display: block;
  }
  ${is('desktop')`
    overflow: auto;
    max-height: calc(100vh - ${({ size }) => (size ? 240 * size : 240)}px);
  `}
  ${is('mobile')`
    overflow: auto;
    max-height: calc(100vh - 132px);
  `}
`

export default BBTabPanel

export interface IBBTabPanelProps {
  desktop?: boolean
  size?: number
  mobile?: boolean
}
